module.exports = __webpack_public_path__ + "img/cinderella-is-dead.b0fe1bab.png";